import React, { useEffect, useState, useContext, useRef } from "react";
import { GlobalContext } from "../contexts/GlobalContext";
import { useNavigate, useLocation, useParams, Outlet } from "react-router-dom";
import {
	PiTrash,
	PiDotsThreeVertical,
	PiMaskHappy,
	PiMaskHappyFill,
	PiMaskHappyLight,
} from "react-icons/pi";
import {YesNoDialog, Scrollable, MsHeader,ContentContainer, ListItem, createPopup, createDialog, QuestionDialog} from "coaz-ui";
import AddRole from "./AddRole";
import client from '../client';

const Roles = () => {
	const { version, setVersion } = useContext(GlobalContext);
	const [roles, setRoles] = useState([]);
	const [buttons, setButtons] = useState([]);
	const [loading, setLoading] = useState(true);
	const [itemButtons, setItemButtons] = useState(null);
	const { roleId } = useParams();
	const {request,getCurrent,errorMessage} = client;
	const path = useLocation().pathname;

	const navigate = useNavigate();

	const onAddRole = (e) => {
		createDialog({
            title:"Add Role",
            Component:AddRole,
            version:version,
            setVersion:setVersion
        })
	};

	const getRoles = async () => {
		await request("GET", "roles")
			.then((response) => {
				if (response && response.length) {
					setRoles(response);
				}
			})
			.catch((error) => {
				console.log(error);
			});
	};

	const openRole = (item) => {
		if (!item || !item.id) return;
		navigate(`${path}/_role/${item.id}`);
	};

	const handleDeleteRole = (item) => {
		if (!item || !item.id) return;
		createDialog({
            title:'Delete Role',
            submitText:"Yes",
            cancelText:"No",
            params:{
                submit:async (e) => {
                        try {
                            await request("DELETE", `roles/${item.id}`)
                            return {
                                message: 'Successful',
                                success: true
                            };
                        } catch (error) {
                            return {
                                message: errorMessage(error)
                            };
                        }
                    },
                message:`Are you sure you want to delete ${item.text}?`
            },
            Component:QuestionDialog,
            version:version,
            setVersion:setVersion
        })
	};

	const load = async () => {
		!loading && setLoading(true);
		const current = await getCurrent();

		if (!current) return;

		let createRole = current.authorities.find((auth) => {
			return auth.authority === "ROLE:CREATE";
		});
		let deleteRole = current.authorities.find((auth) => {
			return auth.authority === "ROLE:DELETE";
		});

		if (createRole) {
			setButtons([
				{
					Icon: PiMaskHappy,
					name: "Add Role",
					handler: onAddRole,
				},
			]);
		}

		if (deleteRole) {
			setItemButtons([
				{
					name: "Delete",
					Icon: PiTrash,
					handler: handleDeleteRole,
				},
			]);
		}
		await getRoles();
		setLoading(false);
	};

	useEffect(() => {
		load();
	}, [version]);

	if (roleId) {
		return <Outlet />;
	} else {
		return (
			<ContentContainer
				buttons={buttons}
				Icon={PiMaskHappyLight}
				text="Roles"
				scrollable={true}
				background={true}
				loading={loading}
			>
				{roles && roles.length > 0 && (
					<div className="flex flex-col w-full h-auto space-y-2">
						{roles.map((role, i) => (
							<ListItem
								key={i}
								Icon={PiMaskHappyLight}
								item={{ id: role.ref.id, text: role.name }}
								buttons={!role.reserved ? itemButtons : null}
								handleOpen={openRole}
							/>
						))}
					</div>
				)}
			</ContentContainer>
		);
	}
};

export default Roles;